import { render, staticRenderFns } from "./MergeInfoBanner.vue?vue&type=template&id=76771d68&scoped=true&"
import script from "./MergeInfoBanner.vue?vue&type=script&lang=js&"
export * from "./MergeInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./MergeInfoBanner.vue?vue&type=style&index=0&id=76771d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76771d68",
  null
  
)

export default component.exports